import { render, staticRenderFns } from "./ConfirmActivationDialog.vue?vue&type=template&id=6833ffee&scoped=true&"
import script from "./ConfirmActivationDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmActivationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmActivationDialog.vue?vue&type=style&index=0&id=6833ffee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833ffee",
  null
  
)

export default component.exports